import React, { Dispatch, SetStateAction, useState } from "react";
import { IConductedStoryGameConfig } from "../../../../common/types";
import ConductedStoryPlayersSelection from "./ConductedStoryPlayersSelection";
import ConductedStoryGameSettings from "./ConductedStoryGameSettings";

interface Props {
    nextToPlay: () => void;
    backToDetails: () => void;
    config: IConductedStoryGameConfig;
    changeConfig: Dispatch<SetStateAction<IConductedStoryGameConfig>>;
}

export enum ConfigStep {
    PLAYERS = "players",
    SETTINGS = "settings"
}

const ConductedStoryGameConfig = ({config, changeConfig, nextToPlay, backToDetails}: Props) => {
    const [configStep, setConfigStep] = useState(ConfigStep.PLAYERS);
    
    const toPlayersSelection = () => {
        setConfigStep(ConfigStep.PLAYERS);
    };

    const toSettings = () => {
        setConfigStep(ConfigStep.SETTINGS);
    };
  
    const playersSelection = <ConductedStoryPlayersSelection
        config={config}
        changeConfig={changeConfig}
        backToDetails={backToDetails}
        nextToSettings={toSettings}
        />;

    const gameSettings = <ConductedStoryGameSettings
        moveBack={toPlayersSelection}
        moveForward={nextToPlay}
        config={config}
        changeConfig={changeConfig}
        />;
    return  configStep === ConfigStep.PLAYERS ? playersSelection : gameSettings;
};

export default ConductedStoryGameConfig;